import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Motion, spring } from 'react-motion';

import { withStyles } from '@material-ui/core/styles';

import InvoicePage from './Invoice';

import ClientPicker from '../clients/ClientPicker';
import ClientProjects from '../clients/ClientProjects';
const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
  },
  content: {
    flexGrow: 1
  }
});

const InvoicingPage = ({classes, invoice}) => {
  return(
    <div className={classes.root}>

      <div className={classes.content}>
        {invoice &&
          <InvoicePage/>
        }
        {!invoice &&
          <div>
            <Motion defaultStyle={{x: -20, y: -20, opacity: 0}}
                    style={{
                      x: spring(0),
                      y: spring(0),
                      opacity: spring(1, { stiffness: 90, damping: 10})
                    }}>
                {(style) => (
                  <div style={{
                      opacity: style.opacity
                    }}>
                    <ClientPicker />
                  </div>
                )}
            </Motion>
            <ClientProjects />
          </div>
        }
      </div>
    </div>
  );
}


InvoicingPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  invoice: state.adminState.invoice,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(InvoicingPage);



// WEBPACK FOOTER //
// ./src/components/admin/Invoicing.jsx